import Grid from "@mui/material/Unstable_Grid2/Grid2"
import OneModal from "../../../../Components/OneModal/OneModal"
import { Typography } from "@mui/material"
import OneTextArea from "../../../../Components/OneTextArea/OneTextArea"
import OneButton from "../../../../Components/OneButton/OneButton"
import Search from "@mui/icons-material/Search"
import { Edit, Save } from "@mui/icons-material"
import { useState, useContext, useEffect, useRef } from "react"
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"

const ModalInfoImovel = ({ id_central, user, imovel, open, setOpen, atualizarNovaObservacaoNaTelaAnterior }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const [observacao, setObservacao] = useState("")
    const [editCaptionButton, setEditCaptionButton] = useState(true)
    const [iconButton, setIconButton] = useState(Edit)
    const textAreaRef = useRef(null);

    useEffect(() => {
        setObservacao(imovel?.observacao || "")
    }, [imovel])

    const handleEditObservacao = () => {
        if (!editCaptionButton) {
            sendWs('auditoriaImovel', {
                id_central: id_central,
                login: user.login,
                id: user.id,
                id_imovel: imovel.id,
                observacao
            })
        }
        atualizarNovaObservacaoNaTelaAnterior(observacao)
        setEditCaptionButton(!editCaptionButton)
        setIconButton(editCaptionButton ? Save : Edit)
    }

    useEffect(() => {
        if (!editCaptionButton) {
            textAreaRef.current?.focus();
        }
    }, [editCaptionButton]);

    const handleTextoObservacao = (e) => {
        setObservacao(e.target.value);
    }
    useEffect(() => {
        addRoute('auditoriaImovel', auditoriaImovel);
    }, [])
    const auditoriaImovel = (msg) => {
        if (msg.data?.success) {
            console.log('Observação salva com sucesso!')
            setEditCaptionButton(true);
            setIconButton(Edit);
        } else {
            console.error('Erro: ', msg.data?.error || 'Erro desconhecido')
        }
    }

    return (
        <OneModal
            open={open}
            setOpen={setOpen}
            titleText="Informações do imóvel"
        >
            <Grid container sx={container1}>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item xs={12}>
                            <Typography>Bloco: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.unidade1}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Apartamento: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.unidade2}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Prefixo Ramal: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.telefone}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Ramal: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.ramal}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Telefone: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.telefone}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Vagas Garagem: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.vagas_garagem}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Vagas Disponíveis: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={formGroupTextValue}>{imovel.vagas_disponiveis}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography>Observações: </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <OneTextArea
                                inputRef={textAreaRef}
                                value={observacao}
                                readOnly={editCaptionButton}
                                onChange={handleTextoObservacao}
                                newSx={textAreaSx}
                            />
                        </Grid>
                        {/* <OneButton variant="outlined" size="medium" color="one_primary" IconStart={Edit} sxIconStart={{ width: '20px' }} onClick={() => console.log('xxx')} > <span style={{ fontSize: '11px' }}>Editar Observações</span> </OneButton> */}
                        <OneButton
                            color="one_primary"
                            isColorDefault={false}
                            newSx={buttonSx}
                            IconStart={iconButton} sxIconStart={{ width: '20px' }}
                            onClick={handleEditObservacao} >
                            {editCaptionButton ? 'Editar' : 'Salvar'} Observações
                        </OneButton>
                    </Grid>
                </Grid>
            </Grid>
        </OneModal>
    )
}

export default ModalInfoImovel

const container1 = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: '20px'
}
const formGroupTextValue = {
    fontWeight: 'bold'

}
const textAreaSx = {
    height: '100px',
    width: '100%'
}

const buttonSx = {
    marginTop: '10px',
    border: '1px solid #000000',
    minWidth: '90px',
    backgroundColor: '#9c27b0cc',
    color: 'white',
    ":hover": {
        backgroundColor: 'transparent',
        color: '#600385',
        border: "1px solid #600385"
    }
}
